/* app/js/src/components/common/link/link.component.scss */
.cursor-pointer {
  cursor: pointer;
}
a {
  color: #879baf;
  text-decoration: none;
  font-size: 0.9em;
  display: inline-block;
  margin-top: 0.4em;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
a:hover {
  color: #ffffff;
}
a.active {
  color: #ffffff;
}
a i {
  margin-left: 0.5rem;
}
/*# sourceMappingURL=link.component.css.map */
